module.exports = __webpack_public_path__ + "static/media/example_message_hr.21f06009.png";